<script lang="ts">
  import { CheckCircle2 } from "@lucide/svelte";
  import type { ConfiguratorAttribute, ConfiguratorTerm } from "../../../types";

  type Props = {
    attribute: ConfiguratorAttribute;
    terms: ConfiguratorTerm[];
    selectedValue?: string;
    onSelect: (slug: string) => void;
  };

  let { attribute, terms, selectedValue, onSelect }: Props = $props();

  // Check if any terms have images
  const hasImages = $derived(terms.some((term) => term.image));
</script>

{#if hasImages}
  <!-- Image grid layout for visual attributes (colors, etc.) -->
  <div class="wpc-options-grid">
    {#each terms as term (term.id)}
      {@const isSelected = selectedValue === term.slug}
      <label class="wpc-option-card {isSelected ? 'wpc-option-card--selected' : ''}">
        <input
          type="radio"
          class="wpc-sr-only"
          name={attribute.slug}
          value={term.slug}
          checked={isSelected}
          onchange={() => onSelect(term.slug)}
        />

        {#if term.image}
          <img
            src={term.image}
            alt={term.name}
            loading="lazy"
            decoding="async"
            class="wpc-option-card__image"
          />
        {/if}

        <p class="wpc-option-card__name">{term.name}</p>

        <!-- Checkmark overlay when selected -->
        {#if isSelected}
          <div class="wpc-option-card__check">
            <CheckCircle2 size={16} color="white" />
          </div>
        {/if}
      </label>
    {/each}
  </div>
{:else}
  <!-- Radio list layout for text-only attributes -->
  <div class="wpc-options-list">
    {#each terms as term (term.id)}
      {@const isSelected = selectedValue === term.slug}
      <label class="wpc-option-item {isSelected ? 'wpc-option-item--selected' : ''}">
        <input
          type="radio"
          class="wpc-radio"
          name={attribute.slug}
          value={term.slug}
          checked={isSelected}
          onchange={() => onSelect(term.slug)}
        />
        <span>{term.name}</span>
      </label>
    {/each}
  </div>
{/if}
